import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';

import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';

export interface LoginOTPVerificationCSSStyle extends UIComponentCSSStyle{
    
    getHeaderDivCSSStyle(): object ;
    getTitleCSSStyle(): object ;
    getMobileTitleCSSStyle(): object;
    getCloseIconDivCSSStyle(): object ;
    getCloseIconCSSStyle(): object ;
    getMobileNumberCSSStyle():object;
    getResendButtonCSSStyle(isRestricted:boolean):object;
}

export class LoginOTPVerificationCSSStyleImpl extends UIComponentCSSStyleImpl
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "100%",
            height: "auto",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            borderRadius: "8px",
            flexFlow: "row wrap",
            position:'relative',
            objectFit:'fill',
            justifyContent:'center',
            itemAlign:'center',
            paddingBottom:'60px'
        };
    }

    getHeaderDivCSSStyle(): object 
    {
        return {
            // backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "45px",
            display: "flex",
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "50px",
            marginLeft:'31.5px',
            marginRight:'31.5px'

        };
    }
    getResendButtonCSSStyle(isRestricted:boolean): object 
    {
        if(isRestricted)
        {
            return {
           
            cursor:"no-drop",
            width:'100%',
            height:'100%',
            lineHeight:'20px',
            color:'#ED0C6E',
            fontSize:'15px',
            textAlign: "left",
            fontWeight:300
        };
    }
    else{
        return {
            width:'100%',
            height:'100%',
            lineHeight:'20px',
            color:'#ED0C6E',
            fontSize:'15px',
            fontWeight:300,
            cursor:"pointer",
            textAlign: "left"    
            
        };
    }
    }

    getTitleCSSStyle(): object {
        return {
           
            // fontSize: this.getResources().getFont(Fonts.h12),
            color:"#000000",
           
        };
    }

    getMobileTitleCSSStyle(): object {
        return {
            width: "90%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "40px" : "40px",
            paddingRight: "0px",
            fontSize: "18px",
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center",
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "45px",
            width: "100%",
            justifyContent: "right",
            textAlign: "right",
            alignItems: "right",
            marginRight: "15px",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "32px",
            width: "32px",
            marginTop: "15px",
            cursor: "pointer"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/login/loginotpverification/loginotpverificationcss.tsx